module.exports = __webpack_public_path__ + "img/setting.d6254e82.svg";